import { ChannelType } from 'components/ChannelPicker/types';
import { Customer } from 'data/firestore/agent/customer/types';

const resolveChannel = ({
    channel,
    customer,
}: {
    customer?: Customer;
    channel?: string
}): ChannelType => {
    if (channel) {
        if (channel?.startsWith('Chatbot.')) return 'widget_chatbot';
        return channel as ChannelType;
    }
    if (customer?.channel) {
        return customer.channel as ChannelType;
    }
    return 'all';
};

export default resolveChannel;
